/** The design source's Over/Under/On-Plan derivation, verbatim: actual vs planned headcount.
 *
 * ONE frontend copy (the MISS_REASONS/FA_REASONS dedup doctrine): CommercialTab's crew-loading
 * table re-exports it, and the timesheet form's entry-time overload advisory (validation set,
 * decision f) consumes the same function — never a parallel derivation. It lives in its own
 * module because CommercialTab's import graph (MsaRatesPanel → bidService → HttpService) does
 * not initialise under jest, and the sharing must not couple the timesheet tab to it. */
export const crewStatus = (planned: number, actual: number): 'Over' | 'Under' | 'On Plan' =>
  (actual > planned ? 'Over' : actual < planned ? 'Under' : 'On Plan');
